'use strict';

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Forms = Forms || {};

// This validates all forms on init
// Also has public functions to validate on demand or check if a form is validated
Forms.Validation = function () {
  var form = void 0,
      allInputs = void 0,
      groupInputs = void 0,
      allSelectEls = void 0,
      checkboxInputs = void 0,
      honeypotInput = void 0,
      config = {},
      dataChecks = {};

  // This inits validation on all forms
  var init = function init() {
    // Cycle through all forms, bind validations
    ;[].concat(_toConsumableArray(document.querySelectorAll('[data-validate-form]'))).forEach(function (thisForm) {
      _setConfigs(thisForm);
      _bindOnBlurValidations();
      _bindOnChangeValidations();
      _bindCheckboxValues();
      _bindClearErrorOnFocus();
      _bindClearGrouptErrorsOnFocus();
    });
  };

  /*
   * Sets the form configurations and module variables
   *
   * @access private
   * @param {HTMLObject} Target form
   * @return {}
   */
  var _setConfigs = function _setConfigs(thisForm) {
    // Set target form if it has not already been set.
    form = thisForm;

    // Basic configs
    config.inputAttr = 'data-input-validate';
    config.groupIdAttr = 'data-input-group-id'; // This is assigned to every field in a group
    config.honeypotAttr = 'data-form-honeypot';
    config.errorClasses = {
      single: 'input-error',
      group: 'input-group-error'
    };

    config.groupOptions = {
      single: 'required-group-single', // At least one element is present and validates
      all: 'required-group-all' // All elements are present and validate


      // Data attribute validation options and their methods
    };dataChecks['required'] = _checkRequired; // Only applied to required single fields
    dataChecks['full-name'] = _checkFullName;
    dataChecks['email'] = _checkEmailFormat;
    dataChecks['phone'] = _checkPhoneFormat;
    dataChecks['state'] = _checkAbbreviatedStateName;
    dataChecks['zip'] = _checkZipFormat;
    dataChecks['url'] = _checkUrlFormat;

    // Create shared var containing all inputs with validation assignments as arrays
    allInputs = [].concat(_toConsumableArray(form.querySelectorAll('[' + config.inputAttr + ']')));
    groupInputs = [].concat(_toConsumableArray(form.querySelectorAll('[' + config.groupIdAttr + ']')));
    allSelectEls = [].concat(_toConsumableArray(form.querySelectorAll('select[' + config.inputAttr + ']')));
    // All checkboxes excluding the honeypot which has it's own dedicated validation and is not user input
    checkboxInputs = [].concat(_toConsumableArray(form.querySelectorAll('[type=checkbox]:not([' + config.honeypotAttr + '])')));
    honeypotInput = form.querySelector('[' + config.honeypotAttr + ']');
  };

  // ========= Public methods
  // For external calls on any form that has validation data attributes.
  // These methods take a form HTMLElement to target for validation. Must be provided.
  //
  var isValid = function isValid(thisForm) {
    _setConfigs(thisForm);

    return _validateForm();
  };

  var isHoneypotClear = function isHoneypotClear(thisForm) {
    _setConfigs(thisForm);

    return _checkHoneyPotClear();
  };

  var clearErrors = function clearErrors(thisForm) {
    _setConfigs(thisForm);
    _clearAllErrors();
  };
  // ========= End Public methods

  // ========= Input error class handling.
  // These take either an HTMLElement or an HTMLCollection and handle error classes.
  //
  var _setError = function _setError(input) {
    input.classList.add(config.errorClasses.single);
  };

  var _clearError = function _clearError(input) {
    input.classList.remove(config.errorClasses.single);
  };

  var _setGroupError = function _setGroupError(_ref) {
    var _ref2 = _toArray(_ref),
        inputGroup = _ref2.slice(0);

    inputGroup.forEach(function (input) {
      return input.classList.add(config.errorClasses.group);
    });
  };

  var _clearGroupError = function _clearGroupError(_ref3) {
    var _ref4 = _toArray(_ref3),
        inputGroup = _ref4.slice(0);

    inputGroup.forEach(function (input) {
      return input.classList.remove(config.errorClasses.group);
    });
  };

  var _clearAllErrors = function _clearAllErrors() {
    allInputs.forEach(function (el) {
      var _el$classList;

      (_el$classList = el.classList).remove.apply(_el$classList, _toConsumableArray(Object.values(config.errorClasses)));
    });
  };
  // ========= End error class handling

  // ========= Data check methods.
  // All of these methods take an HTMLElement as an argument and return a Bool value
  // if valid or not. Only _checkRequired returns false if the input is empty
  var _checkRequired = function _checkRequired(input) {
    return !!input.value.length;
  };

  // Validates that a single input asking for a full name contains a full name (at least first/last)
  var _checkFullName = function _checkFullName(input) {
    var formatRegex = /([!@#$%^&*()_+={}()[\]|\\:;"<>?\/])/;

    return !input.value || input.value.split(' ').length >= 2 && !formatRegex.test(input.value);
  };

  // Validates a phone number input as 10 digit integer. Allows for almost all US formats
  var _checkPhoneFormat = function _checkPhoneFormat(input) {
    var formatRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

    return !input.value || formatRegex.test(input.value);
  };

  // Validates a zip code input as a 5 digit integer
  var _checkZipFormat = function _checkZipFormat(input) {
    return !input.value || parseInt(input.value, 10) && input.value.length === 5;
  };

  // Simple validation for proper email address formatting.
  var _checkEmailFormat = function _checkEmailFormat(input) {
    var formatRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return !input.value || formatRegex.test(input.value);
  };

  // Validates an state input for formatting as 2 alpha chars.
  var _checkAbbreviatedStateName = function _checkAbbreviatedStateName(input) {
    return !input.value || input.value.length == 2 && !input.value.replace(/[A-Za-z]/g, '');
  };

  // Validates a basic email format. Allows:
  // https://www.example.com, http://www.example.com, www.example.com, example.com
  var _checkUrlFormat = function _checkUrlFormat(input) {
    var formatRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;

    return !input.value || formatRegex.test(input.value);
  };

  // Validates a group of inputs together. Returns true if at least one input has a value.
  var _checkInputGroupSingleRequired = function _checkInputGroupSingleRequired(input) {
    return _getAllInputsInGroup(input).filter(_checkRequired).length >= 1;
  };

  // Validates a group of inputs together. Returns true if all inputs have a value.
  var _checkInputGroupAllRequired = function _checkInputGroupAllRequired(input) {
    var inputsInGroup = _getAllInputsInGroup(input);

    return inputsInGroup.length === inputsInGroup.filter(_checkRequired).length;
  };

  // Checks honeypot state.
  var _checkHoneyPotClear = function _checkHoneyPotClear() {
    return !honeypotInput || !honeypotInput.checked;
  };
  // ========= End data check methods

  /**
   * Validates the input based on it's data-form-validate values.
   *
   * @access private
   * @param {HTMLElement} The input to be validated
   * @return {bool}
   */
  var _validateInput = function _validateInput(input) {
    var inputCheckTypes = input.getAttribute(config.inputAttr).split(' '),
        isValid = false,
        validChecks = null;

    // Strip all leading/trailing whitespace from input value
    input.value = input.value.trim();

    // Remove any group validation check attribute values
    inputCheckTypes = inputCheckTypes.filter(function (type) {
      return !Object.values(config.groupOptions).includes(type);
    });

    // Run validations on each validation type, then filter out the results for truthy vals (passed checks)
    validChecks = inputCheckTypes.filter(function (type) {
      return dataChecks[type](input);
    });

    isValid = validChecks.length == inputCheckTypes.length;
    isValid ? _clearError(input) : _setError(input);

    return isValid;
  };

  /**
   * Takes an input and validates/checks all elements with it's group ID.
   *
   * @access private
   * @param {input} input in group to be validated
   * @return {}
   */
  var _validateInputGroup = function _validateInputGroup(input) {
    var inputsInGroup = _getAllInputsInGroup(input);

    var groupCheckResult = inputsInGroup.filter(function (el) {
      var dataChecks = el.getAttribute(config.inputAttr).split(' ');

      if (dataChecks.includes(config.groupOptions.single)) {
        return _checkInputGroupSingleRequired(input);
      } else if (dataChecks.includes(config.groupOptions.all)) {
        return _checkInputGroupAllRequired(input);
      }
    });

    !groupCheckResult.length && _setGroupError(inputsInGroup);
  };

  /**
   * Executes all validations and returns a boolean for form valid or not
   *
   * @access private
   * @return {bool}
   */
  var _validateForm = function _validateForm() {
    var eClasses = Object.values(config.errorClasses).map(function (eClass) {
      return '.' + eClass;
    });

    // Validate group inputs
    groupInputs.forEach(_validateInputGroup);
    // Validate individual non-group inputs
    allInputs.filter(function (input) {
      return !input.hasAttribute(config.groupIdAttr);
    }).forEach(_validateInput);

    return !form.querySelectorAll(eClasses).length && _checkHoneyPotClear();
  };

  /**
   * Binds validations to blur events for elements requiring it.
   *
   * @access private
   * @return {bool}
   */
  var _bindOnBlurValidations = function _bindOnBlurValidations() {
    allInputs.forEach(function (el) {
      el.addEventListener('blur', function () {
        _validateInput(this);
      });
    });
  };

  /**
   * Binds validation on change for elements that should not on blur.
   *
   * @access private
   * @return {}
   */
  var _bindOnChangeValidations = function _bindOnChangeValidations() {
    allSelectEls.forEach(function (el) {
      el.addEventListener('change', function () {
        _validateInput(this);
      });
    });
  };

  /**
   * Binds a focus event on all inputs that removes an error if focused
   *
   * @access private
   * @return {}
   */
  var _bindClearErrorOnFocus = function _bindClearErrorOnFocus() {
    allInputs.forEach(function (input) {
      input.addEventListener('focus', function () {
        _clearError(this);
      });
    });
  };

  /**
   * Binds a focus event on all input groups if field in group is focused
   *
   * @access private
   * @return {}
   */
  var _bindClearGrouptErrorsOnFocus = function _bindClearGrouptErrorsOnFocus() {
    groupInputs.forEach(function (input) {
      input.addEventListener('focus', function () {
        _clearGroupError(_getAllInputsInGroup(input));
      });
    });
  };

  /**
   * Returns array of all elements within the group of the provided input element
   *
   * @access private
   * @param {HTMLElement} Input with id of group to get all inputs with
   * @return {Array}
   */
  var _getAllInputsInGroup = function _getAllInputsInGroup(input) {
    var groupId = input.getAttribute(config.groupIdAttr);

    return [].concat(_toConsumableArray(form.querySelectorAll('[' + config.groupIdAttr + '=' + groupId + ']')));
  };

  // TODO: MOVE THIS TO INTERFACE
  /**
   * Assigns a yes or no value to all checkboxes. Does not validate.
   *
   * @access private
   * @return {}
   */
  var _bindCheckboxValues = function _bindCheckboxValues() {
    checkboxInputs.forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        this.value = this.checked ? 'yes' : 'no';
      });
    });
  };

  return {
    init: init,
    isValid: isValid,
    isHoneypotClear: isHoneypotClear,
    clearErrors: clearErrors
  };
}();